import React, {Component} from 'react';
import Api from "../../utils/Api";
import moment from "moment";
import TimeRange from "../../utils/TimeRange";
import LoadingSplash from "../../globalComponents/LoadingSplash";
import StaticFunctions from "../../utils/StaticFunctions";
import TimerangeSelector from "../../globalComponents/TimerangeSelector";
import TableContainer from "../../utils/TableContainer";
import MachineStates from "../../utils/MachineStates";
import LocationSelector from "../../globalComponents/LocationSelector";
import ShiftSelector from "../../globalComponents/ShiftSelector";
import CSVDownloadButton from "../../utils/CSVDownloadButton";

class ReportDailyDesign extends Component {
/*
    static propTypes = {
        baseData: PropTypes.object.isRequired,
        machines: PropTypes.instanceOf(Machines).isRequired,
    };
*/
    constructor(props) {

        super(props);

        this.api = new Api();

        this.translate = this.props.baseData.translate;
        this.userLanguage = this.props.baseData.userData.language;
        this.timeFormats = this.props.baseData.languages.getFormatByLanguage(this.userLanguage);
        this.saveSettings = this.props.baseData.saveSettings;

        this.state = {
            reportStatus: null,
            reportParams: null,
            timeRange: null, // TimeRange
            selectedLocationId: 0,
            selectedLocationName: 'all',
            selectedShift: null,
            currentCompanyId: props.baseData.companies.currentCompany ? props.baseData.companies.currentCompany.id : null,
            requestedParams: null, // stringified parameters to prevent double-request
            tableData: null,
            errorData: null
        };

        this.reportKey = 'dailyDesign';

        this.requestReport = this.requestReport.bind(this);
        this.timerangeChanged = this.timerangeChanged.bind(this);
        this.locationSelected = this.locationSelected.bind(this);
        this.shiftSelected = this.shiftSelected.bind(this);
        this.getTableColumns = this.getTableColumns.bind(this);
        this.getTableHeader = this.getTableHeader.bind(this);
        this.getTableRows = this.getTableRows.bind(this);

    }

    componentWillMount() {

        const newState = {};

        // Timerange aus den userprops laden
        const tr = new TimeRange();
        const momentYesterday = moment().add(-1, 'days');

        tr.setRange(momentYesterday.clone().startOf('day'), momentYesterday.clone().endOf('day'));

        if (tr && tr.isValid()) newState.timeRange = tr;

        // Standort aus den userprops laden
        const locationId = this.getReportSetting('locationId');

        if (locationId) newState.selectedLocationId = locationId;

        // Shift aus den userprops laden
        const sid = this.getReportSetting('shiftId');

        if (sid) {
            let shift = this.props.baseData.shifts.getShiftById(sid);

            if (shift) newState.selectedShift = shift;
        }

        if (newState) {
            this.setState(newState);
        }

    }

    getReportSetting(key, defaultValue = null) {

        const settings = this.props.baseData.userData.settings ? this.props.baseData.userData.settings : {};
        const reportSettings = (settings.hasOwnProperty('reports') && settings.reports.hasOwnProperty(this.reportKey)) ? settings.reports[this.reportKey] : {};

        return (reportSettings.hasOwnProperty(key)) ? reportSettings[key] : defaultValue;

    }

    getRequestParams() {

        const tr = this.state.timeRange;
        const dateFrom = tr ? tr.getFromMoment() : null;
        const dateTill = tr ? tr.getTillMoment() : null;
        const locationId = this.state.selectedLocationId;

        // Check, if all data is set
        if (!dateFrom || !dateTill || locationId === null) return null;
        if (!dateFrom.isValid() || !dateTill.isValid()) return null;

        return {
            companyId: this.props.baseData.companies.currentCompany.id,
            locationId: locationId,
            from: dateFrom.unix(),
            till: dateTill.unix(),
            shift: this.state.selectedShift ? this.state.selectedShift.getRange() : null,
            timezone: this.props.baseData.companies.currentCompany.timezone,
        };

    }

    requestReport() {

        if (this.state.reportStatus === 'requested') return null;

        const params = this.getRequestParams();

        if (params === null) return null;

        const sParams = JSON.stringify(params);

        if (sParams === this.state.requestedParams) return null;

        const {reportParams, ...newReportParams} = {...this.state};

        const callback = function(res) {
            if (res) {
                const sortedDesigns = StaticFunctions.getSortedData(res, 'key', 'string');

                this.setState({
                    reportStatus: 'ready',
                    tableData: sortedDesigns,
                    errorData: null,
                });
            }
        }.bind(this);

        const error = function(error) {
            if (error) {
                this.setState({
                    reportStatus: 'error',
                    tableData: null,
                    errorData: error,
                });
            }
        }.bind(this);

        this.setState({
            reportStatus: 'requested',
            reportParams: newReportParams,
            requestedParams: sParams,
            tableData: null,
            errorData: null,
        }, () => {
            this.api.request("ReportDailyDesign", params, callback, error);
        });

    }

    timerangeChanged(newRange) {

        if (newRange && (newRange instanceof TimeRange) && newRange.isValid()) {
            this.setState({
                timeRange: newRange,
            });

            // Safe Timerange to Userconfig
            if (this.saveSettings) {
                this.saveSettings('reports', {report: this.reportKey, key: 'timeRange', value: newRange.serialize()});
            }
        }

    }

    locationSelected(location) {

        this.setState({
            selectedLocationId: location ? parseInt(location.id) : 0,
            selectedLocationName: location ? location.name : '',
        });

        if (this.saveSettings && location) {
            this.saveSettings('reports', {report: this.reportKey, key: 'locationId', value: location.id});
        }

    }

    shiftSelected(shift) {

        this.setState({
            selectedShift: shift
        });

        // Safe Shift-id to Userconfig
        if (this.saveSettings && shift) {
            this.saveSettings('reports', {report: this.reportKey, key: 'shiftId', value: shift.id});
        }

    }

    getErrorBlock() {

        let errorBlock = null;

        if (this.state.errorData || this.state.reportStatus === 'error') {
            errorBlock = <span className="warningBox ma-bo-10">{this.translate('errorOccured')}</span>;
        } else if (!this.state.reportParams.timeRange || !this.state.reportParams.timeRange.isValid()) {
            errorBlock = <span className="warningBox ma-bo-10">{this.translate('timerangeIsUnset')}</span>;
        } else if (!this.state.reportParams.timeRange || !this.state.reportParams.timeRange.isNotInFuture()) {
            errorBlock = <span className="warningBox ma-bo-10">{this.translate('timerangeIsInFuture')}</span>;
        } else if (!this.state.reportParams && this.state.reportParams.selectedLocationId === null) {
            errorBlock = <span className="warningBox ma-bo-10">{this.translate('locationIsUnset')}</span>;
        } else if (!this.state.reportParams && this.state.reportParams.selectedDesign === null) {
            errorBlock = <span className="warningBox ma-bo-10">{this.translate('designIsUnset')}</span>;
        } else if (this.state.tableData === null) {
            errorBlock = <LoadingSplash color={'dark'}/>;
        } else if (this.state.tableData && this.state.tableData.length === 0) {
            errorBlock = <span className="warningBox ma-bo-10">{this.translate('noDataFound')}</span>;
        }

        return (errorBlock !== null) ? errorBlock : null;

        return null;

    }

    getChartHeadline(timeRange, otherParams = {}) {

        const params = {
            location: {id: this.state.reportParams.selectedLocationId, name: this.state.reportParams.selectedLocationName},
			locationTitle: this.translate('location'),
			allLocationsTitle: this.translate('allLocations'),
            design: this.state.reportParams.selectedDesign,
            designTitle: this.translate('design'),
            allDesignsTitle: this.translate('allDesigns'),
            timerange: timeRange,
            formatedDate: this.timeFormats.fullDate,
            timerangeTitle: this.translate('timerange'),
            shift: this.state.reportParams.selectedShift,
            shiftTitle: this.translate('shift'),
            groupingOpt: this.groupingOpt,
            groupingId: this.state.reportParams.selectedGrouping,
            groupingTitle: this.translate('grouping')
        };

        return StaticFunctions.createReportHeadlineFromParams({...params, ...otherParams});

    }

    getTableHeader() {

        const location = {
            location: {id: this.state.reportParams.selectedLocationId, name: this.state.reportParams.selectedLocationName},
            locationTitle: this.translate('location'),
            allLocationsTitle: this.translate('allLocations')
        };

        const headline = this.getChartHeadline(this.state.reportParams.timeRange, location);

        return (
            <nav>
                <h1>{headline}</h1>
            </nav>
        );

    }

    getCsvContent() {

        const csvContent = {
            csvTitle: [],
            csvColumns: [],
            csvData: [],
        };

        if (this.state.reportStatus === 'ready') {
            const location = {
                location: {id: this.state.reportParams.selectedLocationId, name: this.state.reportParams.selectedLocationName},
                locationTitle: this.translate('location'),
                allLocationsTitle: this.translate('allLocations')
            };

            csvContent.csvTitle.push(this.getChartHeadline(this.state.reportParams.timeRange, location));
            csvContent.csvColumns.push(this.getTableColumns());
            csvContent.csvData.push(this.getTableRows());
        }

        return csvContent;

    }

    getTableColumns() {

        return [
            {
                key: 'designId',
                nameKey: 'designId',
                sortType: 'string',
            },
            {
                key: 'designStitches',
                nameKey: 'designStitches',
				classes: 'text-right',
                sortType: 'int',
            },
            /*{
                key: 'totalStitches',
                nameKey: 'totalStitches',
                classes: 'text-right',
                sortType: 'int',
            },
            {
                key: 'totalThreadbreaks',
                nameKey: 'totalThreadbreaks',
                classes: 'text-right',
                sortType: 'int',
            },*/
            {
                key: 'totalCompletions',
                nameKey: 'passings',
                classes: 'text-right',
                sortType: 'int',
            },
            {
                key: 'totalPieces',
                nameKey: 'numberOfPieces',
                classes: 'text-right',
                sortType: 'int',
            },
            {
                key: 'productiveTime',
                nameKey: 'productionTime',
                classes: 'text-right',
                sortType: 'string',
            },
            {
                key: 'downTime',
                nameKey: 'downTime',
                classes: 'text-right',
                sortType: 'string',
            },
            {
                key: 'totalTime',
                nameKey: 'totalTime',
                classes: 'text-right',
                sortType: 'string',
            },
        ];

    }

    getTableRows() {

        const data = this.state.tableData;

        if (!data) return [];

        const sums = {
            id: "sum",
            designId: this.translate("sum"),
            totalStitches: 0,
            totalThreadbreaks: 0,
            totalCompletions: 0,
            totalPieces: 0,
            totalTime: 0,
            downTime: 0,
            productiveTime: 0

        };

        const rows = data.map((patternInfo, index) => {
            const row = {
                id: index,
                designId: patternInfo.designId,
				designStitches: StaticFunctions.formatedNumber(patternInfo.stitches),
                totalStitches: 0,
                totalThreadbreaks: 0,
                totalCompletions: 0,
                totalPieces: 0,
                totalTime: 0,
                downTime: 0,
                productiveTime: 0
            };

            patternInfo.data.forEach((statusInfo) => {
                if (statusInfo.status === "1012") {
                    const heads = this.props.machines.getMachineHeadsByMachineId(statusInfo.machineId);

                    row.totalCompletions += (+statusInfo.status_count);
                    row.totalPieces += (+statusInfo.status_count) * heads;
                    sums.totalCompletions += (+statusInfo.status_count);
                    sums.totalPieces += (+statusInfo.status_count) * heads;
                }

                if (MachineStates.getProductionStatusList().includes(+statusInfo.status)) {
                    row.productiveTime += +statusInfo.duration;
                    sums.productiveTime += +statusInfo.duration;
                }

                if (MachineStates.getDownStatusList().includes(+statusInfo.status)) {
                    row.downTime += +statusInfo.duration;
                    sums.downTime += +statusInfo.duration;
                }

                if (MachineStates.getTotalStatusList().includes(+statusInfo.status)) {
                    row.totalTime += +statusInfo.duration;
                    sums.totalTime += +statusInfo.duration;
                }

                row.totalStitches += +statusInfo.stitches;
                row.totalThreadbreaks += +statusInfo.threadbreaks;
                sums.totalStitches += +statusInfo.stitches;
                sums.totalThreadbreaks += +statusInfo.threadbreaks;
            });

            row.totalCompletions = StaticFunctions.formatedNumber(row.totalCompletions);
            row.totalPieces = StaticFunctions.formatedNumber(row.totalPieces);
            row.totalTime = StaticFunctions.convertSecondsToFormatedString(row.totalTime / 1000);
            row.productiveTime = StaticFunctions.convertSecondsToFormatedString(row.productiveTime / 1000);
            row.downTime = StaticFunctions.convertSecondsToFormatedString(row.downTime / 1000);

            return row;
        });

        sums.totalCompletions = StaticFunctions.formatedNumber(sums.totalCompletions);
        sums.totalPieces = StaticFunctions.formatedNumber(sums.totalPieces);
        sums.totalTime = StaticFunctions.convertSecondsToFormatedString(sums.totalTime / 1000);
        sums.productiveTime = StaticFunctions.convertSecondsToFormatedString(sums.productiveTime / 1000);
        sums.downTime = StaticFunctions.convertSecondsToFormatedString(sums.downTime / 1000);

        if (rows.length) {
            rows.push(sums);
        }

        return rows;

    }

    renderRequestButton() {

        const reportParams = this.getRequestParams();
        const sParams = JSON.stringify(reportParams);

        if (this.state.reportStatus === 'requested' || sParams === this.state.requestedParams) {
            return (
                <a className="prewLink disabled-link">{this.translate('requestReport')}</a>
            );
        } else {
            return (
                <a className="prewLink orangeButton" onClick={() => this.requestReport()}>{this.translate('requestReport')}</a>
            );
        }

    }

    renderDownloadButtons() {

        if (this.state.reportStatus !== 'ready' || !this.state.reportParams || this.getErrorBlock() !== null) {
            return (
                <div className="bottomLinks clearfix">
                    <div><button className="disabled-link">{this.translate('csvDownloadLabel') + ' (CSV)'}</button></div>
                </div>
            );
        } else {
            const csvContent = this.getCsvContent();

            return (
                <div className="bottomLinks clearfix">
                    <CSVDownloadButton
                        baseData={this.props.baseData}
                        fileName={this.props.reportName}
                        csvTitle={csvContent.csvTitle}
                        columns={csvContent.csvColumns}
                        data={csvContent.csvData}
                    />
                </div>
            );
        }

    }

    renderReportArea() {

        if (this.state.reportStatus === null) return null;
        if (this.state.reportStatus === 'requested') return <LoadingSplash color={'dark'}/>;

        const errorBlock = this.getErrorBlock();

        if (errorBlock !== null) return errorBlock;

        const tableHeader = this.getTableHeader();
        const tableColumns = this.getTableColumns();
        const tableRows = this.getTableRows();

        return (
            <div className="ma-bo-10">
                {tableHeader}

                <TableContainer
                    baseData={this.props.baseData}
                    columns={tableColumns}
                    rows={tableRows}
                />
            </div>
        );

    }

    render() {

        const timerangeFormat = this.timeFormats.fullDate;
        const reportArea = this.renderReportArea();
        const requestButton = this.renderRequestButton();
        const downloadArea = this.renderDownloadButtons();

        return (
            <div>
                <div id="reportSettings" className="clearfix">
                    <div className="clearfix">
                        <div className="col-sm-4">
                            <div className="ma-bo-10">
                                <h4>{this.translate('timerange')}</h4>

                                <div>
                                    <TimerangeSelector
                                        TimeRange={this.state.timeRange}
                                        displayFormat={timerangeFormat}
                                        translate={this.translate}
                                        onTimeRangeChanged={this.timerangeChanged}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="col-sm-2">
                            <div className="ma-bo-10">
                                <h4>{this.translate('location')}</h4>

                                <div>
                                    <LocationSelector
                                        baseData={this.props.baseData}
                                        currentLocation={this.state.selectedLocationId}
                                        placeholder={this.translate('select') + '...'}
                                        onLocationSelected={(location) => this.locationSelected(location)}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="col-sm-2">
                            <div className="ma-bo-10">
                                <h4>{this.translate('shift')}</h4>

                                <div>
                                    <ShiftSelector
                                        baseData={this.props.baseData}
                                        currentShift={this.state.selectedShift}
                                        translate={this.translate}
                                        onShiftSelected={(shift) => this.shiftSelected(shift)}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="col-sm-2">
                            <div className="ma-bo-10">
                                <h4>{this.translate('downloadReport')}</h4>

                                {downloadArea}
                            </div>
                        </div>
                    </div>

                    <div className="bottomLinks clearfix">
                        {requestButton}
                    </div>
                </div>

                <div id="reportArea" className="clearfix">
                    {reportArea}
                </div>
            </div>
        );

    }

}

export default ReportDailyDesign;
